import React from 'react';
import { AlertCircle, CheckCircle2, Building2, Clock, Circle } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * ClientFilterChips - Barre de filtres décisionnels pour clients
 */
const ClientFilterChips = ({ activeFilter, onFilterChange, counts = {} }) => {
  
  const filters = [
    {
      id: 'needs_action',
      label: 'Action requise',
      icon: AlertCircle,
      color: 'orange',
      count: counts.needs_action || 0
    },
    {
      id: 'active',
      label: 'Actifs',
      icon: CheckCircle2,
      color: 'green',
      count: counts.active || 0
    },
    {
      id: 'inactive',
      label: 'Inactifs',
      icon: Clock,
      color: 'gray',
      count: counts.inactive || 0
    },
    {
      id: 'prospects',
      label: 'Prospects',
      icon: Building2,
      color: 'blue',
      count: counts.prospects || 0
    },
    {
      id: 'all',
      label: 'Tous',
      icon: Circle,
      color: 'slate',
      count: counts.all || 0
    }
  ];

  const getActiveStyles = (filter) => {
    if (activeFilter !== filter.id) {
      return 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50';
    }
    
    switch (filter.color) {
      case 'orange':
        return 'bg-orange-500 border-orange-500 text-white';
      case 'green':
        return 'bg-green-500 border-green-500 text-white';
      case 'gray':
        return 'bg-gray-500 border-gray-500 text-white';
      case 'blue':
        return 'bg-blue-500 border-blue-500 text-white';
      default:
        return 'bg-gray-700 border-gray-700 text-white';
    }
  };

  const getIconColor = (filter) => {
    if (activeFilter === filter.id) return 'text-white';
    
    switch (filter.color) {
      case 'orange': return 'text-orange-500';
      case 'green': return 'text-green-500';
      case 'gray': return 'text-gray-400';
      case 'blue': return 'text-blue-500';
      default: return 'text-gray-500';
    }
  };

  return (
    <div 
      className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide"
      data-testid="client-filter-chips"
    >
      {filters.map((filter) => (
        <button
          key={filter.id}
          onClick={() => onFilterChange(activeFilter === filter.id ? 'all' : filter.id)}
          className={cn(
            "flex items-center gap-1.5 px-3 py-2 rounded-full border text-sm font-medium whitespace-nowrap transition-all",
            getActiveStyles(filter)
          )}
          data-testid={`client-filter-${filter.id}`}
        >
          <filter.icon className={cn("h-4 w-4", getIconColor(filter))} />
          {filter.label}
          {filter.count > 0 && (
            <span className={cn(
              "ml-1 px-1.5 py-0.5 rounded-full text-xs font-bold",
              activeFilter === filter.id 
                ? "bg-white/20 text-white" 
                : "bg-gray-100 text-gray-600"
            )}>
              {filter.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default ClientFilterChips;
